import './index.css';

interface VideoItem {
  url: string;
  title: string;
}

interface QueueListProps {
  queue: VideoItem[];
  onRemove?: (index: number) => void;
  onReorder?: (fromIndex: number, toIndex: number) => void;
  className?: string;
}

const decodeHtml = (html: string) => {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

const QueueList = ({ queue, onRemove, className = '' }: QueueListProps) => (
  <div className={`queue-container ${className}`}>
    <h2 className='queue-header'>
      Queue {queue.length > 0 && <span className='queue-count'>({queue.length})</span>}
    </h2>

    {queue.length === 0 ? (
      <p className='queue-empty-message'>The queue is empty</p>
    ) : (
      <ul className='queue-list'>
        {queue.map((video, index) => (
          <li key={`${video.url}-${index}`} className='queue-item'>
            <span className='queue-item-number'>{index + 1}.</span>
            <span className='queue-item-title'>{decodeHtml(video.title)}</span>
            {onRemove && (
              <button
                className='queue-item-remove'
                onClick={() => onRemove(index)}
                aria-label={`Remove ${video.title} from queue`}>
                ×
              </button>
            )}
          </li>
        ))}
      </ul>
    )}
  </div>
);

export default QueueList;
